import React from "react";
import {LinkIcon} from "@heroicons/react/outline";

export function SourceLink(props) {
    return <li>
        <a className="flex items-center link-sm" href={props.url} target="_blank">
            <LinkIcon className="h-4 w-4 mr-1"/>{props.title}</a>
    </li>;
}